import { type FC } from 'react';

import { ServicePeriodItem } from '@/components/AdvertisePayments/components/ExtraContent/ExtraContent.types';
import { useThemeMode } from '@/hooks/useThemeMode';

import * as S from './ExtraContent.styles';

type ModalExtraContentServicePeriodListItemProps = {
  periodItem: ServicePeriodItem;
  isActiveCard: boolean;
  onSelect: () => void;
};

export const ModalExtraContentServicePeriodListItem: FC<
  ModalExtraContentServicePeriodListItemProps
> = ({ periodItem, isActiveCard, onSelect }) => {
  const isDark = useThemeMode('dark');

  return (
    <S.PlanOptionButton
      type="button"
      $isActiveCard={isActiveCard}
      aria-pressed={isActiveCard}
      onClick={onSelect}
    >
      <S.PlanOptionContent>
        <S.PlanDuration $isActiveCard={isActiveCard} $isDark={isDark}>
          {periodItem.count}
        </S.PlanDuration>
        <S.PlanPeriodLabel>{periodItem.periodTime}</S.PlanPeriodLabel>
        <S.PlanPrice $isActiveCard={isActiveCard} $isDark={isDark}>
          {periodItem.price}
        </S.PlanPrice>
      </S.PlanOptionContent>
    </S.PlanOptionButton>
  );
};
